import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";

const AddEditApuTypes = ({ params, toggleModalFn, addEditApuTypes, getResponseBack, modeType }) => {
    const [data, setData] = useState(addEditApuTypes?.data);
    const [error, setError] = useState({ modal: false , data: null })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [manufacturersInfo, setManufacturersInfo] = useState([]);
    const [aircraftTypeInfo, setAircraftTypeInfo] = useState([]);

    useEffect(() => {
        if (modeType === 'add' || modeType === 'edit') {
            getManufacturers();
            getAircraftType();
        }
    }, []);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }

    const isDataChanged = () =>{
        const originalData = addEditApuTypes?.data || {};
        const getIdArray = (arr) => (arr || []).map(item => item?.id).sort();
        const currentIds = getIdArray(data?.aircraft_type);
        const originalIds = getIdArray(originalData?.aircraft_type);
        const areLinkedTypesSame = JSON.stringify(currentIds) === JSON.stringify(originalIds);
        return(
            data?.name !== originalData?.name ||
            data?.manufacturer?.id !== originalData?.manufacturer?.id ||
            !areLinkedTypesSame ||
            data?.remarks !== originalData?.remarks
        );
    };

    const getManufacturers = () => {
        globalGetService(`config-data/manufacturers/?lite=true`)
           .then(response => {
                if (checkApiStatus(response)) {
                    let manufacturersInfo = [];
                    const data = response.data.data;
                    data.map((item) => {
                        manufacturersInfo.push({ id: item?.id, name: item?.name })
                    });
                    setManufacturersInfo(manufacturersInfo);
                }
            })
    }

    const getAircraftType = () => {
            globalGetService(`config-data/aircraft-type/?lite=true`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        let aircraftTypeInfo = [];
                        const data = response?.data?.data;
                        data && data.map((item) => {
                            aircraftTypeInfo.push({ id: item?.id, name: item?.name })
                        });
                        setAircraftTypeInfo(aircraftTypeInfo);
                    }
                })
        }

    const onAddEditApuTypes = () => {

        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter Name',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);

            let payload = Object.assign({}, data);

            payload = {
                id: payload?.id || null,
                name: payload?.name || null,
                manufacturer: payload?.manufacturer || {},
                aircraft_type: payload?.aircraft_type ? payload.aircraft_type : [],
                remarks: payload?.remarks || null,
            };            

            const apiUrl = data?.id ? `config-data/apu-type/bulk-update/` : `config-data/apu-type/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl,[payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Apu Types Data Updated Successfully' : 'Apu Types Data Added Successfully',
                            page_title: 'Config Data : Apu Types',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true , data:response?.data?.error_details})
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Apu Types Updated Failed' : 'Apu Types Data Added Failed',
                            page_title: 'Config Data : Apu Types',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }

    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit' : modeType === 'view' ? 'Veiw' : 'Add'} APU Type
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    options={(manufacturersInfo || []).filter((item) => item.id !== data?.manufacturer?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    id="manufacturer" 
                                    disabled={modeType === 'view'}
                                    value={data?.manufacturer || null}
                                    onChange={(e, value) => onFieldChange('manufacturer', value)}
                                    renderInput={params => <TextField placeholder={'Please select Manufacturer'}  {...params} label='Manufacturer' margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <Autocomplete
                                    options={aircraftTypeInfo.filter((item) => !(data?.aircraft_type || []).some((selected) => selected.id === item.id))}
                                    getOptionLabel={option => option?.name}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    id="aircraft_type"
                                    multiple={true}
                                    disabled={modeType === 'view'}
                                    value={data?.aircraft_type || []}
                                    onChange={(e, value) => { onFieldChange('aircraft_type', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Aircraft Type'}  {...params} label={'Aircraft Type'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Apu Types', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Apu Types form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditApuTypes(); trackActivity('Console Management', { page_title: 'Config Data : Apu Types', item_type: 'Save Button', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Apu Types form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) => 
            <ErrorPopUp 
              toggleModalFn={() => setError({ modal:false , data:null})}
              modal={error.modal}
              error={item}
            />)}
        </>
    )
}
export default AddEditApuTypes;